import { SagaIterator } from "redux-saga";
import { call, put, takeEvery } from "typed-redux-saga";

import { UaaActions } from "@com.mgmtp.a12.uaa/uaa-authentication-client";

import { RESOURCE_KEYS } from "../../localization";
import { putErrorNotification } from "../../utilities/notificationUtils";

import { setEnvironmentData } from "../slices/environmentData/reducers";
import { isEnvironmentData } from "../slices/environmentData/types";

import { fetchSagaFactory } from "./fetchSagaFactory";

export function* loadEnvironmentDataSaga(): SagaIterator<void> {
	yield* takeEvery(
		UaaActions.loggedIn,
		fetchSagaFactory(
			{
				method: "GET",
				relativeUrl: "/environment-data",
				customHeaders: [["Accepts", "application/json"]]
			},
			function* handleResponse(response) {
				const environmentData = yield* call(response.json.bind(response));

				if (isEnvironmentData(environmentData)) {
					yield* put(setEnvironmentData(environmentData));
				} else {
					yield* call(
						putErrorNotification,
						RESOURCE_KEYS.features.notification.error.environmentData,
						undefined,
						undefined,
						"getEnvironmentData"
					);
				}
			},
			function* handleError(error) {
				yield* call(
					putErrorNotification,
					RESOURCE_KEYS.features.notification.error.environmentData,
					error,
					undefined,
					"getEnvironmentData"
				);
			}
		)
	);
}
